const { cELM, getAnswerVariableCssClass, getQuestionTestId, globalCollabProvidersState } = require("../../utils.js");
const Provider = require("../blocks/provider.js");
const Option = require("../blocks/option.js");
const Question = require("../blocks/question.js");
const { cloneDeep } = require('lodash');

class CollaboratingProviders {
  constructor(params) {
    this._params = params;
    this._data = params.data;
    this.copyParams = cloneDeep(params);
    const cssVariableKey = getAnswerVariableCssClass(this._data);
    this._element = cELM("div", `component-block ${cssVariableKey}`);
    this._calendar = null;

    this.createElement();
  }

  initializeGlobalState(providerId) {
    if (!Object.keys(globalCollabProvidersState).includes(providerId)) {
      globalCollabProvidersState[providerId] = { clicked: false, lastDateRendered: null };
    }
  }

  createElement() {
    const value = this._data;
    const testId = getQuestionTestId(value);
    testId && this._element.setAttribute('data-testid', testId);
    value.status && this._element.classList.add(value.status);
    value.format && this._element.classList.add(value.format);

    this._element.classList.remove("singleselect");
    this._element.classList.remove("singleselect-insurance");
    this._element.classList.add("singleselectflex");

    // -------- Primary Provider -----------
    if (this._data.format) {
      const clinicIconBlock = new Provider(this._params);
      this._element.addELM(clinicIconBlock);
    }
    const selectApptTextBlock = new Question({ data: { text: 'Select an appointment date & time below.' } });
    this._element.addELM(selectApptTextBlock);

    const primaryProviderBlock = new Question(this._params);
    this._element.addELM(primaryProviderBlock);

    this._params.data.providerSlots = this._data.specificSlotsPerProvider[0]?.timeSlots;
    this._params.data.isCollabProvidersView = true;
    this._params.data.loadingState = false;
    this._params.data.currentProvider = this._data.primaryProviderId;

    this.initializeGlobalState(this._data.primaryProviderId);

    this._calendar = new Option(this._params);
    if (this._calendar.getHTML() && value.status !== "typing") {
      this._element.addELM(this._calendar);
    }
    // --------------------------------------

    // Collaborating Providers
    let collabProviderBlock;
    let calendarBlock;

    for (const provider of this._data.specificSlotsPerProvider) {
      if (provider.providerId === this._data.primaryProviderId) {
        continue;
      }

      const text = `<div class='provider-info'><div class=img-wrapper><img src="${encodeURI(provider.providerImageUrl)}"></div><div>${provider.name}<div class='provider-info-location'><div>Collaborating Provider</div></div></div></div>`;
      collabProviderBlock = new Question({ data: { text }, style: 'margin-top: 20px' });
      this._element.addELM(collabProviderBlock);

      const newParams = cloneDeep(this.copyParams);
      newParams.data.providerSlots = provider.timeSlots;
      newParams.data.isCollabProvidersView = true;
      newParams.data.loadingState = false;
      newParams.data.currentProvider = provider.providerId;

      this.initializeGlobalState(provider.providerId);

      calendarBlock = new Option(newParams);
      if (calendarBlock.getHTML() && value.status !== "typing") {
        this._element.addELM(calendarBlock);
      }
    }
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }

  updateAnswer(value, callback) {
    this._calendar.updateAnswer(value, this._element, callback);
  }

  focus() {
    this._calendar.focus();
  }
}

module.exports = CollaboratingProviders;
